import gql from 'graphql-tag';

import { LINK_PREVIEW_METADATA_FRAGMENT } from '../LinkMetadata/linkPreviewMetadata';
import { FEED_LINK_PREVIEW_METADATA_DETAILS_FRAGMENT } from '../LinkMetadataDetails/feedLinkPreviewMetadata';
import { POST_NOTIFICATION_FRAGMENT } from '../Notification/postNotification';
import { MENTIONS_PLEX_REGISTERED_USER_FRAGMENT } from '../PlexRegisteredUser/mentionsPlexRegistereduser';
import { FULL_PLEX_USER_RELATION_FRAGMENT } from '../PlexUserRelation/fullPlexUserRelation';

export const FEED_POST_DETAILS_FRAGMENT = gql`
  fragment feedPostDetails on Post {
    id
    currentUserRelation
    deleted
    plex {
      id
      name
      color
      currentUserRelation {
        ...fullPlexUserRelation
      }
    }
    title
    body
    publishStatus
    publishedDate
    picture
    author {
      id
      name
      picture
      jobTitle
    }
    commentsCount
    primaryLink {
      id
      details {
        ...feedLinkPreviewMetadataDetails
      }
    }
    labels {
      id
      name
    }
    notification {
      ...postNotification
    }
    mentions {
      ...mentionsPlexRegisteredUser
    }
    links {
      ...linkPreviewMetadata
    }
    type
    eventDate
    watching
    currentUserReactions
    permalink
  }

  ${FULL_PLEX_USER_RELATION_FRAGMENT}
  ${FEED_LINK_PREVIEW_METADATA_DETAILS_FRAGMENT}
  ${POST_NOTIFICATION_FRAGMENT}
  ${MENTIONS_PLEX_REGISTERED_USER_FRAGMENT}
  ${LINK_PREVIEW_METADATA_FRAGMENT}
`;
